import { SITE } from "@/lib/site";
import Reveal from "@/components/Reveal";

export default function ServiceAreas() {
  return (
    <section
      data-testid="service-areas-section"
      className="relative bg-[#0E1213] py-20 md:py-24 px-6 md:px-12 lg:px-16 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-4">
          <div className="flex items-center gap-4 mb-6">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">Service Areas</span>
          </div>
          <h2 className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB] leading-tight">
            The suburbs we know best.
          </h2>
          <p className="mt-4 text-[#A1A1AA] text-sm">
            Outside this list? We travel — ask us when you call.
          </p>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-8">
          <div className="flex flex-wrap gap-2">
            {SITE.serviceAreas.map((a) => (
              <span
                key={a}
                data-testid={`service-area-${a.toLowerCase().replace(/\s/g, "-")}`}
                className="border border-[#27272A] text-[#F4F0EB]/85 px-4 py-2 text-sm hover:border-[#3FB8DC] hover:text-[#3FB8DC] transition-colors"
              >
                {a}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
